import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { ItemJadwal, Header } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { jadwalUrl } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { showError, showSessionExpired } from "../../helpers/Toast";
import { useNavigate } from "react-router-dom";

const Jadwal = () => {
  const { handleSessionExpired } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const getJadwal = async () => {
    try {
      const response = await fetch(jadwalUrl, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        showError("Gagal memuat jadwal");
        return;
      }

      const result = await response.json();
      setData("data" in result ? result.data : []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJadwal();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Jadwal Presensi</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Jadwal Presensi" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        {isLoading ? (
          <div className="space-y-3 mt-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-2xl h-24 animate-pulse" />
            ))}
          </div>
        ) : data.length > 0 ? (
          data.map((item, index) => (
            <ItemJadwal
              key={index}
              hari={item.hari}
              tgl={item.tgl}
              jadwal_masuk={item.jadwal_masuk}
              jadwal_pulang={item.jadwal_pulang}
            />
          ))
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-10 mt-2 text-center">
            <svg className="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="text-sm text-gray-400">Tidak ada jadwal tersedia</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Jadwal;
